import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import classNames from 'classnames';
import border from '../assets/Rectangle.svg?url';
import Qr from './qr';
import { useStyles } from './QrScanner.styles';
export const QrScanner = ({ onScan }) => {
    const videoEl = useRef(null);
    const overlayEl = useRef(null);
    const qrScanner = useRef(null);
    const { classes } = useStyles();
    const borders = [
        'border_position_top_left',
        'border_position_top_right',
        'border_position_bottom_left',
        'border_position_bottom_right',
    ];
    useEffect(() => {
        if (videoEl.current && overlayEl.current) {
            qrScanner.current = new Qr(videoEl.current, (result) => onScan(result.data), {
                preferredCamera: 'user',
                highlightScanRegion: true,
                highlightCodeOutline: true,
                overlay: overlayEl.current,
                calculateScanRegion(video) {
                    const scanRegionSize = video.videoHeight;
                    return {
                        x: Math.round((video.videoWidth - scanRegionSize) / 2), //eslint-disable-line no-magic-numbers
                        y: Math.round((video.videoHeight - scanRegionSize) / 2), //eslint-disable-line no-magic-numbers
                        width: scanRegionSize,
                        height: scanRegionSize,
                        downScaledWidth: video.videoHeight,
                        downScaledHeight: video.videoHeight,
                    };
                },
            });
            qrScanner.current.start();
        }
        return () => {
            if (qrScanner.current) {
                qrScanner.current.destroy();
                qrScanner.current = null;
            }
        };
    }, [videoEl, onScan]);
    return (_jsxs("div", { className: classes.qrScanner, children: [_jsxs("div", { className: classes.wrapper, children: [_jsx("video", { ref: videoEl, className: classes.video }), _jsx("div", { ref: overlayEl, className: classNames('scan-region-highlight', classes.overlay) })] }), borders.map((position) => (_jsx("img", { src: border, className: classNames(classes.border, classes[position]) }, position)))] }));
};
